import axios from 'axios'
import modals from '~/lib/modals'

export default {
  mixins: [modals],
  data () {
    const $this = this
    return {
      netvisorAccounts: [],
      levelCache: {
        '0': 0
      }
    }
  },
  computed: {
    netvisorVatCodes () {
      const _ = this._
      return {
        'NONE': _('No VAT handling'),
        'KOMY': _('Domestic sales'),
        'EUMY': _('Sales inside the EU'),
        'EUUM': _('Sales outside the EU'),
        '100': _('100%'),
        'EUPM312': '312 ' + _('Sales of services inside the EU'),
        'EUPM309': '309 ' + _('Sales of services inside the EU'),
        'RAMY': _('Sales of construction services')
      }
    }
  },
  methods: {
    loadAccounts () {
      return new Promise(async (resolve) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/accounts.json?apikey=' + this.apiKey)
        } catch(e) {
          this.showError(e)
          resolve([])
          return
        }
        this.netvisorAccounts = response.data
        resolve(response.data)
      })
    },
    accountTitle (account) {
      return this.accountPadding(account) + (parseInt(account.number) ? account.number + ' ' : '') + account.name
    },
    accountPadding (account) {
      const p = account.parentid
      const i = account.id
      if (!this.levelCache[p]) {
        this.levelCache[p] = 0
      }
      this.levelCache[i] = this.levelCache[p] + 1
      return '&nbsp;'.repeat(this.levelCache[i] * 4)
    },
    async netvisorAccountDialog(obj, field) {
      const accounts = await this.loadAccounts()
      this.showDialog({
        title: this._('Netvisor Account'),
        buttons: [
          {
            title: this._('Close'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'check',
            handler: (data) => {
              obj[field] = data.account
            }
          }, 
        ],
        fields: [
          {
            title: this._('Account'),
            type: 'select',
            name: 'account',
            options: accounts.map(a => { return { value: a.number, name: this.accountTitle(a), disabled: !parseInt(a.number) } }),
            defaultValue: parseInt(obj[field]) ? obj[field] : null
          }
        ]
      })
    },
    async netvisorSync () {
      let response
      try {
        response = await axios.put(this.baseDomain + this.shopId + '/settings/1.json?apikey=' + this.apiKey, { netvisorsync: 1 })
      } catch (e) {
        this.showError(e)
        return
      }
      this.showNotification(this._('Synchronization scheduled. It should be complete in a few minutes.'))
    }
  }
}